export default "__VITE_ASSET__CHP_BMzU__"